module.exports = ".main-content {\n  text-align: center;\n  margin: 30px; }\n\n.main-logo {\n  margin: 10px 0 30px 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/pages/main/main.scss
// module id = ./src/app/pages/main/main.scss
// module chunks = main